if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}
function closeNotification() {
        const notification = document.getElementById('notification');
        notification.style.display = 'none';
}
document.addEventListener("DOMContentLoaded", function () {
  
    let t = document.getElementById("notification");
    if (t) {
        // Obtener y procesar atributos
        let e = t.getAttribute("data-nombres-ventas")?.split(";").map((item) => item.trim()) || [];
        let i = t.getAttribute("data-ciudad-pais")?.split(";").map((item) => item.trim()) || [];
        let n = t.getAttribute("data-tiempos-ventas")?.split(";").map((item) => item.trim()) || [];
        let a = t.getAttribute("data-product-title") || "";
        let d = t.getAttribute("data-product-image") || "";

        // Función para actualizar el simulador de ventas
        function updateSimulator() {
            if (e.length === 0 || i.length === 0 || n.length === 0) {
                console.error("Faltan datos en los atributos para el simulador.");
                return;
            }
            let randomLocationIndex = Math.floor(Math.random() * i.length);
            let randomTimeIndex = Math.floor(Math.random() * n.length);

            // Actualizar contenido
            document.getElementById("location").innerText = `${e[randomLocationIndex]} de ${i[randomLocationIndex]} compró:`;
            document.getElementById("purchase").innerText = a;
            document.getElementById("time").innerText = n[randomTimeIndex];
            document.getElementById("face-image").src = d;

            // Mostrar notificación
            t.style.display = "flex";
            setTimeout(() => {
                t.style.display = "none";
            }, 8000); // Ocultar después de 8 segundos
        }

        // Iniciar simulador
        setTimeout(() => {
            updateSimulator();
            setInterval(updateSimulator, 20000); // Actualizar cada 20 segundos
        }, 6000); // Primera ejecución después de 6 segundos
    }
});
function convertDate(date) {
    let d = new Date(date);
    let day = d.getDate();
    return (day < 10 ? "0" + day : day); // Devuelve solo el día en formato de dos dígitos
}

function getMesExtenso(month) {
    const months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Agos", "Sept", "Oct", "Nov", "Dic"];
    return months[month];
}

document.addEventListener("DOMContentLoaded", function() {
    const previewElement = document.querySelector('.shipping-preview-line');
    if (!previewElement) return;

    // Obtiene los valores de los atributos de datos
    const daysFinal = parseInt(previewElement.getAttribute('data-days-final'), 10);
    const daysInitial = parseInt(previewElement.getAttribute('data-days-initial'), 10);
    const showCountryOnly = previewElement.getAttribute('data-show-country-only') === 'true';
    const colorUbicacion = previewElement.getAttribute('data-color-ubicacion');

    let currentDate = new Date();
    let startDate = new Date();
    let endDate = new Date();

    startDate.setDate(currentDate.getDate() + daysInitial);
    endDate.setDate(currentDate.getDate() + daysFinal);

    let startMonthName = getMesExtenso(startDate.getMonth());
    let endMonthName = getMesExtenso(endDate.getMonth());
    let dateRange;

    if (startDate.getMonth() === endDate.getMonth()) {
        dateRange = `<strong>${convertDate(startDate)}</strong> y el <strong>${convertDate(endDate)} de ${startMonthName}</strong>`;
    } else {
        dateRange = `<strong>${convertDate(startDate)} de ${startMonthName}</strong> y <strong>${convertDate(endDate)} de ${endMonthName}</strong>`;
    }

    fetch("https://wtfismyip.com/json")
        .then(response => response.json())
        .then(data => {
            let location = data.YourFuckingLocation;
            let country = data.YourFuckingCountry;
            let displayLocation = showCountryOnly ? country : location;

            document.querySelector(".custom-address").innerHTML = `<font color='${colorUbicacion}'><b>Envío gratis</b></font> para todo <strong><font color='${colorUbicacion}'>${displayLocation}</font></strong>`;
            document.querySelector(".shipping-estimated").innerHTML = `Recibe tu producto entre el: ${dateRange}.`;
            document.querySelector(".shipping-preview-loading").style.display = "none";
        })
        .catch(error => console.error("Error al obtener la ubicación:", error));
});

document.addEventListener("DOMContentLoaded",function() {
    var t,e=document.getElementById("countdown-container-uni");
    if(e) {
        !function t(e) {
            var n,$,o,d=e,a=setInterval(function() {
                n=parseInt(d/3600,10),$=parseInt(d%3600/60,10),o=parseInt(d%60,10),n=n<10?"0"+n:n,$=$<10?"0"+$:$,o=o<10?"0"+o:o,document.getElementById("hours-value").textContent=n,document.getElementById("minutes-value").textContent=$,document.getElementById("seconds-value").textContent=o,--d<0&&(clearInterval(a),t(e))
            },
            1e3)
        }
        (60*parseInt(e.getAttribute("data-timer")))
    }
});
